<!-- 评分标准 -->
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid show-overflow height="90%" :stripe="true" border="default" :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
<!--                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"-->
<!--                              @click="openEditDialog">新增-->
<!--                  </vxe-button>-->
                </div>
                <div class="fr">
                  <!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
                  <!--                              status="primary" plain>重置-->
                  <!--                  </vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
              </vxe-form>
            </template>

            <template #option="{row}">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)">
                <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-edit"/>
                </el-tooltip>
                </a>
              </div>
            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>

              <template #showOrderNode="{ row }">
                <span class="txt-status " v-if="row.orderNode == 1">报单</span>
                <span class="txt-status " v-else-if="row.orderNode == 3">预约</span>
                <span class="txt-status " v-else-if="row.orderNode == 5">上门</span>
                <span class="txt-status " v-else-if="row.orderNode == 7">完结</span>
                <span class="txt-status " v-else-if="row.orderNode == 9">用户评价</span>
                <span class="txt-status " v-else></span>
              </template>

              <template #showNodeProject="{ row }">
                <span class="txt-status " v-if="row.nodeProject == 1">关联安装单</span>
                <span class="txt-status " v-else-if="row.nodeProject == 2">虚拟号外呼记录</span>
                <span class="txt-status " v-else-if="row.nodeProject == 3">APP打卡记录</span>
                <span class="txt-status " v-else-if="row.nodeProject == 4">派单时间距离到达签到时间</span>
                <span class="txt-status " v-else-if="row.nodeProject == 5">完工方式</span>
                <span class="txt-status " v-else-if="row.nodeProject == 6">工单时长</span>
                <span class="txt-status " v-else-if="row.nodeProject == 7">评价方式</span>
                <span class="txt-status " v-else-if="row.nodeProject == 8">评价手机号和用户手机号</span>
                <span class="txt-status " v-else-if="row.nodeProject == 9">收费信息</span>
                <span class="txt-status " v-else></span>
              </template>

            <template #showBussineNode="{ row }">
              <span class="txt-status " v-if="row.serverBusinessType == 1">安装</span>
              <span class="txt-status " v-else-if="row.serverBusinessType == 2">维修</span>
              <span class="txt-status " v-else></span>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import {indexPageMixins} from "@/mixins/tabChang";

export default {
	name: 'push',
  mixins: [indexPageMixins],
  components: {editView, pager},
  data() {
    return {
      total: 0,
      getListPageUrl: '/basic/basScoreStandards/getListPage',
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      dataId2: 0,

      showEdit: false,
      showEdit2: false,

      vxeOption: {},
      // 查询参数
      requestParam: {
        searchCount: true,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
      },
      formData: {
      },
      pageSizes: [10, 20, 100],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '服务性质', field: 'serverBusinessType', width: 142, sortable: true, slots: {default: 'showBussineNode'}},
        {title: '履约节点', field: 'orderNode', width: 142, sortable: true, slots: {default: 'showOrderNode'}},
        {title: '节点子项', field: 'nodeProject', width: 180, sortable: true, slots: {default: 'showNodeProject'}},
        {title: '标准描述', field: 'nodeDescribe', width: 150,},
        {title: '分值', field: 'scores', width: 150,},
        {title: '创建时间',field: 'createTime', width: 150},
        {title: '创建人', field: 'createBy', width: 150,},
        {
          width: 80, fixed: 'right', title: '操作', sortable: false, slots: {
            default: 'option'
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  created() {
    this.push_rule_edit = this.permissions['push_rule_edit']
    this.push_rule_add = this.permissions['push_rule_add']
  },
  mounted() {
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    siteName(n) {
      if (!n) {
        this.formData.siteId = null
      }
    },
    'formData.date': {
      handler(n) {
        if (n != null && n.length > 0) {
          this.formData.beginDate = n[0]
          this.formData.endDate = n[1]
        }
      },
      deep: true
    }
  },
  methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.name = this.formData.name
      this.requestParam.bigCategoryId = this.formData.bigCategoryId
      this.requestParam.smallCategoryId = this.formData.smallCategoryId
      this.requestParam.beginDate = this.formData.beginDate
      this.requestParam.endDate = this.formData.endDate
      this.requestParam.itemName = this.formData.itemName
      this.requestParam.brandId = this.formData.brandId
      this.requestParam.settleLevel = this.formData.settleLevel
      this.requestParam.siteId = this.formData.siteId
      this.requestParam.stat = this.formData.stat
      this.requestParam.ruleName = this.formData.ruleName
      this.requestParam.siteName = this.formData.siteName

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = true
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        bigCategoryId: '',
        smallCategoryId: '',
        name: '',
        beginDate: '',
        endDate: '',
      }

      this.requestParam.searchCount = true
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.bigCategoryId = ''
      this.requestParam.smallCategoryId = ''
      this.requestParam.beginDate = ''
      this.requestParam.endDate = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    // 新增
    openEditDialog2(id) {
      console.log("jjjjjjjjjjjj", id)
      this.dataId2 = 0;
      this.activeName = 'zero';
      this.$openEditView('showEdit2');
    },
    // 删除
    delect(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$http({
          url: '/basic/basPushRule/' + id,
          method: 'post'
        })
      }).then(() => {
        this.searchEvent()
        this.$message.success("删除成功");
      }).catch(() => {
      })
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
